'use es6';

import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Text } from 'foundations-components/components/Text';
import StepInterface from './StepInterface';
import { CHOOSE_PROVIDER_STEP, CUSTOM_EMAIL_DETECT_STEP, EMAIL_INPUT_STEP } from '../../constants/InboxConnectStepKeys';
import { isValidEmail } from '../../utils/Validation';
import { getClientKey } from '../../utils/InboxConnectionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class EmailInputStep extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      email: '',
      emailValid: false,
      showChooseProviderButton: false,
      nextButtonLoading: false,
      nextButtonDisabled: true
    };
    this.displayProviderButton = () => {
      this.setState({
        showChooseProviderButton: true,
        nextButtonLoading: false
      });
    };
    this.onClickNext = () => {
      this.props.trackingClient.trackStepAction(EMAIL_INPUT_STEP, 'clicked next button');
      this.setState({
        nextButtonLoading: true
      });
      this.props.setEmailAddress(this.state.email);
      this.detectClient();
    };
    this.detectClient = () => {
      const {
        service,
        setSelectedClient,
        setShownStep
      } = this.props;
      service.getProviderByEmailAddress(this.state.email).then(provider => {
        const clientKey = getClientKey(provider.get('name'));
        if (clientKey !== null) {
          setSelectedClient(clientKey);
          this.setState({
            nextButtonLoading: false
          });
          setShownStep(CUSTOM_EMAIL_DETECT_STEP);
        } else {
          this.displayProviderButton();
        }
      }).catch(() => {
        this.displayProviderButton();
      });
    };
    this.onClickChooseProvider = () => {
      this.props.trackingClient.trackStepAction(EMAIL_INPUT_STEP, 'clicked choose email provider button');
      const {
        setShownStep
      } = this.props;
      setShownStep(CHOOSE_PROVIDER_STEP);
    };
    this.handleEmailChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        email: value,
        showChooseProviderButton: false,
        nextButtonDisabled: true
      });
      const isEmailValid = Boolean(isValidEmail(value));
      this.setState({
        emailValid: isEmailValid
      });
      if (isEmailValid) this.setState({
        nextButtonDisabled: false
      });
    };
    this.renderButton = () => {
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        children: this.state.showChooseProviderButton ? /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: this.onClickChooseProvider,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'InboxConnectUtils.wizard.emailInput.chooseEmailProvider'
          })
        }) : /*#__PURE__*/_jsx(LoadingButton, {
          "data-test-id": "email-input-step-next-button",
          use: "primary",
          loading: this.state.nextButtonLoading,
          disabled: this.state.nextButtonDisabled,
          onClick: this.onClickNext,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'InboxConnectUtils.wizard.emailInput.next'
          })
        })
      });
    };
    this.handleKeyDownForEmailInput = ({
      keyCode
    }) => {
      if (keyCode === 13) this.onClickNext();
    };
    this.renderEmailInput = () => {
      return /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'InboxConnectUtils.wizard.emailInput.emailLabel'
        }),
        required: true,
        textAlign: "start",
        children: /*#__PURE__*/_jsx(TextInput, {
          name: "email",
          defaultValue: this.state.email,
          placeholder: text('InboxConnectUtils.wizard.emailInput.emailPlaceholder'),
          onChange: this.handleEmailChange,
          onKeyDown: this.handleKeyDownForEmailInput
        })
      });
    };
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(EMAIL_INPUT_STEP);
  }
  render() {
    return /*#__PURE__*/_jsx(Flex, {
      direction: "row",
      justifyContent: "center",
      "data-selenium": "email-input-step",
      children: /*#__PURE__*/_jsxs(View, {
        inlineSize: "420px",
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: "heading-400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'InboxConnectUtils.wizard.emailInput.title'
          })
        }), this.renderEmailInput(), this.state.showChooseProviderButton && /*#__PURE__*/_jsx(View, {
          marginBlockStart: "500",
          children: /*#__PURE__*/_jsx(Text, {
            as: "strong",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'InboxConnectUtils.wizard.emailInput.cannotIdentifyEmail'
            })
          })
        }), this.renderButton()]
      })
    });
  }
}
EmailInputStep.propTypes = StepInterface;